import React from 'react';
import { Form } from 'react-form';
import { Input } from '../../Form';
import Popup from '../../Popup';
import styles from './removeRedshirtStatusPopUp.scss';

const RemoveRedshirtStatusPopUp = props => {
    const {
        onCloseClick,
        onCtaClick,
        playerId,
        playerName,
    } = props;
    const defaultValues = {
        playerId,
    };
    return (
        <Popup
            className="popup-md"
            popUpClassName={styles.popupConfig}
            onCloseClick={onCloseClick}
            config={{
                fullScreen: false,
                noPadding: true,
                gradient: true,
                scrollable: false,
                noHeader: true,
            }}
        >
            <div className={styles.popupContainer}>
                <p className={styles.popupHeader}>
                    Remove Redshirt Status
                </p>
                <p className={styles.popupDetails}>
                    Are you sure you want to remove the redshirt status for {playerName}? If so, please click &quot;Confirm&quot;.
                </p>
                <Form onSubmit={values => onCtaClick(values)} id="removeRedshirtStatusForm" defaultValues={defaultValues}>
                    {({ submitForm }) => {
                        return (
                            <form onSubmit={submitForm} id="removeRedshirtStatusForm">
                                <Input id="playerId" field={'playerId'} value={`${playerId}`} type="hidden" />
                                <div className={styles.buttonContainer}>
                                    <div className={styles.buttonWrapper}>
                                        <button
                                            onClick={onCloseClick}
                                            type="button"
                                            className={`btn btn-default text-uppercase btn-block ${styles.cancelButton}`}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                    <div className={styles.buttonWrapper}>
                                        <button
                                            type="submit"
                                            className={`btn btn-primary text-uppercase btn-block ${styles.submitButton}`}
                                        >
                                            Confirm
                                        </button>
                                    </div>
                                </div>
                            </form>
                        );
                    }}
                </Form>
            </div>
        </Popup>
    );
};

export default RemoveRedshirtStatusPopUp;
